import { defineMessages } from 'react-intl';

const prefix = 'repvisits.search.appointment-details';

const messages = defineMessages({
  address: {
    id: `${prefix}.address`,
    defaultMessage: 'Address',
  },
  collegeGoingRate: {
    id: `${prefix}.collegeGoingRate`,
    defaultMessage: 'College Going Rate',
  },
  counselorCommunity: {
    id: `${prefix}.counselorCommunity`,
    defaultMessage: '\'s Counselor Community Profile',
  },
  details: {
    id: `${prefix}.details`,
    defaultMessage: 'Details | ',
  },
  district: {
    id: `${prefix}.district`,
    defaultMessage: 'District',
  },
  HScontact: {
    id: `${prefix}.hscontact`,
    defaultMessage: 'High School Contact:',
  },
  moreInformation: {
    id: `${prefix}.moreInformation`,
    defaultMessage: 'For more information:',
  },
  noDistrict: {
    id: `${prefix}.noDistrict`,
    defaultMessage: 'No District Information',
  },
  phone: {
    id: `${prefix}.phone`,
    defaultMessage: 'Phone',
  },
  seniorClassSize: {
    id: `${prefix}.seniorClassSize`,
    defaultMessage: 'Senior Class Size',
  },
  type: {
    id: `${prefix}.type`,
    defaultMessage: 'Type',
  },
  nonRepVisits: {
    id: `${prefix}.nonRepVisits`,
    defaultMessage: 'This high school is not using RepVisits yet',
  },
});

export default messages;
